import React from "react";
import "./Home.css";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import splash from "./splash.jpeg";
import kids1 from "./kids-1.jpeg";
import kids3 from "./kids-3.jpeg";
import kids4 from "./kids-4.jpeg"

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div className="content-container">
                    <img className="splash" src={splash} alt="Kid at baseball game"/>
                    <div className="sub-container">
                        <div className="content">
                            <h3>Kids in Seats</h3>
                            <p>is a 501(c)(3) charity organization that incentivizes children with donated tickets.</p>
                            <Link to="/about">ABOUT US</Link>
                        </div>
                        <img src={kids3} alt="Baseball field"/>
                    </div>
                    <div className="sub-container">
                        <img src={kids1} alt="Nonprofit graphic"/> 
                        <div className="content off-color">
                            <h3>How do we do it?</h3>
                            <p>We partner with organizations to bring deserving kids the best experiences possible.</p>
                            <Link to="/about">LEARN MORE</Link>
                        </div>
                    </div>
                    <div className="sub-container">
                        <div className="content">
                            <h3>How can you help?</h3>
                            <Link className="final-buttons" to="/donate">CONTRIBUTE</Link>

                        </div>
                        <img src={kids4} alt="Smiling recipient"/>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}
export default Home;
